/* eslint-disable @typescript-eslint/camelcase */
import request from '@/utils/request'

export const getServices = (timeslotType: string, params: any) =>
   request({
     url: '/statistics/services.show',
     method: 'get',
     params
})

// export const getServices = (status: string, params: any) => {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       return resolve([
//         {
//           id: 55,
//           user_profile_id: 10,
//           customer_profile_id: 6,
//           service_id: 1,
//           service_title: 'Como correr',
//           date_at: '2021-01-18',
//           time_from: '10:00',
//           time_to: '11:30',
//           price: '1.50',
//           timeslot_type: 'Confirmed',
//           remind_customer_is_send: 0,
//           created_at: '2021-01-15T20:04:41.000000Z',
//           updated_at: '2021-01-15T20:04:57.000000Z',
//           meeting_link: null,
//           orders: [

//           ],
//           service: {
//             id: 1,
//             title: 'Como correr',
//             price: 1,
//             price_per: 'hr',
//             duration: '01:30',
//             location_id: 2,
//             format_id: 2,
//             user_profile_id: 10,
//             last_provision_at: null,
//             state: 'Active',
//             deleted_at: null,
//             created_at: '2020-11-27T19:32:56.000000Z',
//             updated_at: '2020-12-18T20:13:10.000000Z',
//             price_to_be_agreed: 1,
//             type: {
//               id: 2,
//               term_id: 2,
//               type: 'service_type',
//               description: null,
//               _lft: 504,
//               _rgt: 505,
//               parent_id: 1,
//               created_at: '2020-06-02T14:33:48.000000Z',
//               updated_at: '2020-06-02T14:33:48.000000Z',
//               pivot: {
//                 entity_id: 1,
//                 taxonomy_id: 2,
//                 entity_type: 'App\\Domains\\Service\\Models\\Service'
//               },
//               term: {
//                 id: 2,
//                 name: 'Entrenador Personal',
//                 slug: 'entrenador-personal',
//                 meta: [
//                   {
//                     price_to_be_agreed: true
//                   }
//                 ],
//                 created_at: '2020-06-02T14:33:48.000000Z',
//                 updated_at: '2020-06-02T14:33:48.000000Z'
//               }
//             },
//             location: null,
//             format: null,
//             speciality: {
//               id: 3,
//               term_id: 3,
//               type: 'speciality',
//               description: null,
//               _lft: 283,
//               _rgt: 284,
//               parent_id: 2,
//               created_at: '2020-06-02T14:33:48.000000Z',
//               updated_at: '2020-06-02T14:33:48.000000Z',
//               image: null,
//               pivot: {
//                 entity_id: 1,
//                 taxonomy_id: 3,
//                 entity_type: 'App\\Domains\\Service\\Models\\Service'
//               },
//               term: {
//                 id: 3,
//                 name: 'Gimnasios',
//                 slug: 'gimnasio',
//                 meta: [
//                   {
//                     price_to_be_agreed: true
//                   }
//                 ],
//                 created_at: '2020-06-02T14:33:48.000000Z',
//                 updated_at: '2020-06-02T14:33:48.000000Z'
//               },
//               media: [

//               ]
//             },
//             service_provider: {
//               id: 10,
//               profile_type: 'Business',
//               name: 'Proveedor',
//               cedula: '231012828',
//               gender: 'Female',
//               phone: '+593610176308',
//               birthday: null,
//               bio: 'experiencia laboral',
//               address: 'Francisco Segura 16, Guayaquil 090416, Ecuador',
//               lat: '41.22439740',
//               lng: '1.73147500',
//               review_requests_meta: [

//               ],
//               isHidden: false,
//               created_at: '2020-11-29T17:18:36.000000Z',
//               updated_at: '2021-01-15T14:00:52.000000Z',
//               max_number_of_documents: 3
//             }
//           },
//           customer_profile: {
//             id: 6,
//             lat: '-2.15778050',
//             lng: '-79.90014450',
//             phone: '+593366884887',
//             home_address: 'Victor Hugo Sicouret 19, Guayaquil 090506, Ecuador',
//             legal_name: 'Marcos Morales',
//             id_number: '12345678',
//             created_at: '2020-11-27T21:15:20.000000Z',
//             updated_at: '2020-12-01T18:55:41.000000Z'
//           }
//         }
//       ])
//     }, 1000)
//     setTimeout(() => {
//       return setTimeout(() => {
//         // eslint-disable-next-line prefer-promise-reject-errors
//         return reject({})
//       }, 5000)
//     })
//   })
// }
